<template>
  <div id="slider-wrapper">
    <div class="slider">
      <h2 id="form-title">{{title}}</h2>
      <div id="slider-inputs">
        <span v-for="(option, key) in options" :key="key">
          <input
            v-model="inputVal"
            type="radio"
            name="debt-amount"
            :id="option.value"
            :value="option.value"
            required
          />
          <label :style='language == "en" ? "" : "white-space: nowrap;"' :for="option.value" :slider-label-value="option.value"></label>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["options", "value", "title", "language"],
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>

<style lang='scss' scoped>
$number-of-options: 10;

#slider-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.slider {
  width: 100%;
  #form-title {
    margin-top: 0;
    font-weight: 400;
    text-align: center;
    color: #88ad3f;
    margin-bottom: 20px;
  }
  #slider-inputs {
    display: flex;
    flex-direction: row;
    align-content: stretch;
    position: relative;
    width: 100%;
    height: 50px;
    user-select: none;
    justify-content: space-between;

    &::before {
      content: " ";
      position: absolute;
      height: 2px;
      //width: 100%;
      //   width: calc(
      //     100% * (#{$number-of-options - 1}0.5 / #{$number-of-options})
      //   );
      width: calc(100% - 10px);
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #000;
    }
    span {
      input,
      label {
        box-sizing: border-box;
        flex: 1;
        user-select: none;
        cursor: pointer;
      }
      label {
        display: inline-block;
        position: relative;
        width: 20%;
        height: 100%;
        user-select: none;
        &::before {
          content: attr(slider-label-value);
          position: absolute;
          left: 50%;
          padding-top: 15px;
          transform: translate(-50%, 16px);
          line-height: 20px;
          font-size: 14px;
          letter-spacing: 0.4px;
          font-weight: 400;
          // white-space: nowrap;
          opacity: 0.85;
          transition: all 0.15s ease-in-out;
        }
        &::after {
          content: " ";
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 30px;
          height: 30px;
          border: 2px solid #000;
          background: #88ad3f;
          border-radius: 50%;
          pointer-events: none;
          user-select: none;
          z-index: 1;
          cursor: pointer;
          transition: all 0.15s ease-in-out;
        }
        &:hover::after {
          transform: translate(-50%, -50%) scale(1.25);
        }
      }
      input {
        display: none;
        &:checked {
          + label::before {
            font-weight: 800;
            opacity: 1;
          }
          + label::after {
            border-width: 4px;
            transform: translate(-50%, -50%) scale(0.75);
          }
        }
      }
    }
  }
}
@keyframes spin {
  from {
    transform: rotate(0deg);
    width: 24px;
    opacity: 1;
    margin-right: 12px;
  }
  to {
    transform: rotate(360deg);
    width: 24px;
    opacity: 1;
    margin-right: 12px;
  }
}

@media screen and (max-width: 599px) {
  .slider {
    #slider-inputs {
      height: fit-content;
      margin-top: 2rem;
      flex-direction: column;
      align-items: flex-start;
      align-content: flex-start;
      justify-content: flex-start;

      &::before {
        display: none;
      }

      span > label {
        width: 100%;
        padding: 0;

        &::before {
          position: static;
          top: 0;
          left: 0;
          display: inline-block;
          transform: none;
          line-height: 30px;
          white-space: nowrap;
        }
        &::after {
          display: inline-block;
          line-height: 30px;
          position: absolute;
          left: 50%;
          top: 20%;
          transform: translate(-50%, -50%);
          width: 25px;
          height: 25px;
        }
      }
    }
  }
}
</style>